import { client } from './client';

export function apiGetTeams() {
  const headers = {
    'Content-Type': 'application/json',
  };
  return client.get('teams');
}
